import { useQuery } from '@tanstack/react-query';
import { auditService } from '../services/auditService';
import type { AuditQueryParams } from '../types';

export function useAuditLogs(params: AuditQueryParams = {}) {
  return useQuery({
    queryKey: ['audit-logs', params],
    queryFn: () => auditService.getLogs(params),
  });
}
